<template>
  <div>
    <v-dialog/>
    <!--右侧内容-->
    <div class="class_add_top"> <a class="back" onclick="history.go(-1)">返回</a>编辑标签 </div>
    <div class="class_add_con">
      <form data-vv-scope="form">
        <table width="100%" border="0" cellspacing="0" cellpadding="0">
          <tr class="tita">
            <td class="left_td">标签信息</td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <td class="left_td pt20">标签名称：</td>
            <td class="pt20">
              <input type="text" name="content" v-validate="'required'" v-model="params.content" placeholder="60字以内" v-bind:maxlength="60" class="put_495" />
              <div class="error_msg_tip">{{ errors.first('form.content') }}</div>
            </td>
          </tr>
          <tr>
            <td class="left_td pt20" valign="top">标签分类：</td>
            <td class="pt20 rdiv">
              <input type="hidden" name="classification" id="classification" v-model="params.classificationId" v-validate="'required'">
              <div class="treeSelect">
                <treeselect
                  :options="options"
                  :value="params.classificationId"
                  :searchable="false"
                  :show-count="true"
                  placeholder="--请选择分类--"
                  v-model="params.classificationId"
                >
                </treeselect>
              </div>
              <div class="error_msg_tip">{{ errors.first('form.classification') }}</div>
            </td>
          </tr>
          <tr>
            <td class="left_td">标签图标：</td>
            <td class="rdiv pt20">
              <!--<input type="hidden" v-model="params.style" name="style" v-validate="'required'">-->
              <img v-if="params.style && params.style!==''" :src="params.style"  class="upload_img" style="left: 100px; width: 90px; height: 90px;"/>
              <UploadOSS :uploadOSSConf="uploadOSSConf" :DOM_ID="'style'" v-if="uploadOSSConf.STS!=null"  @success = "OSSUploadSuccess"></UploadOSS>
              <p class="mt10"><span class="tips_text">建议图片长90px宽90px，支持jpg、jpeg、png，图片大小不超过2MB</span></p>
              <!--<div class="error_msg_tip">{{ errors.first('form.style') }}</div>-->
            </td>
          </tr>
        </table>
        <p class="btn_center">
          <input type="button" class="all_btn" value="保存提交" @click="editResource('form')"/>
        </p>
      </form>
    </div>
    <!--/右侧内容-->
  </div>
</template>
<script>
  import utils from '@/utils'
  import Treeselect from '@riophae/vue-treeselect'
  import UploadOSS from '@/components/common/upload/uploadOSS.vue'
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'
  import '@/utils/validator.js'
  export default {
    components: { Treeselect, UploadOSS },
    data () {
      return {
        options: [],
        params: {
          classification: null
        },
        resourceType: '',
        RCTree: [],
        prefix: this.$route.meta.prefix || '',
        uploadOSSConf: { showMode: '1', style: 'img_upload5', typeArr: 'image/png,image/jpg,image/jpeg', catalog: 'byl', fileName: '', maxSize: '2000000', STS: null }
      }
    },
    created () {
      if (this.$route.params.id === 'create') {
        this.params = {
          classificationId: null
        }
      } else {
        this.getResource(this.$route.params.id)
      }
      this.getResourceClassification()
    },
    mounted () {
      this.getSTS()
      this.OSSUploadSuccess()
    },
    computed: {
    },
    methods: {
      confirmBox (o) {
        var that = this
        this.$modal.show('dialog', {
          title: '提交',
          text: '确认提交吗？',
          buttons: [
            {
              title: '确认',
              default: false,
              handler: utils.debounce(() => {
                if (o.yes && o.yes instanceof Function) {
                  o.yes()
                  that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
                }
              }, 1000)
            },
            {
              title: '取消'
            }
          ]
        })
      },
      getResource (id) {
        this.$api.get(this.$global.tagApiPath, '/tagInfo/get', {id: id}, r => {
          if (r.data) {
            this.params = r.data
            this.resourceType = this.params.type
          }
        })
      },
      editResource (scope) {
        var self = this
        this.$validator.validateAll(scope).then(function (result) {
          if (result) {
            if (!self.params.classificationId) {
              self.$toasted.show('请选择标签分类！', {
                duration: 800
              })
            } else {
              self.confirmBox({
                yes: function () {
                  self.$api.post(self.$global.tagApiPath, '/tagInfo/edit', self.params, r => {
                    self.$router.push({path: self.prefix + '/org/tagList'})
                  })
                }
              })
            }
          } else {
            self.$toasted.show('请确保信息正确与完整！', {
              duration: 800
            })
            return false
          }
        })
      },
      dealTree (arr) {
        var dealArr = []
        if (arr && arr.length > 0) {
          for (var i = 0; i< arr.length; i++) {
            var temp = {
              id: arr[i].id,
              label: arr[i].name
            };
            if (arr[i].nodes && arr[i].nodes.length > 0) {
              temp.children = []
              for (var j = 0; j < arr[i].nodes.length; j++) {
                var child = {
                  id: arr[i].nodes[j].id,
                  label: arr[i].nodes[j].name
                }
                temp.children.push(child)
              }
            }
            dealArr.push(temp)
          }
        }
        return dealArr
      },
      getResourceClassification () {
        this.$api.get(this.$global.tagApiPath, '/tagClassification/findList', {}, r => {
          let tree = r.data
          this.options = this.dealTree(tree)
        })
      },
      getSTS () {
        this.$api.get(this.$global.resourceApiPath, '/common/getSTS', {}, r => {
          let STS = [r.data.expiration, r.data.accessKeyId, r.data.accessKeySecret, r.data.securityToken, r.data.endpointClean, r.data.bucket, r.data.region]
          this.uploadOSSConf.STS = STS
        })
      },
      OSSUploadSuccess (r) {
        if (r && r != '') {
          this.$set(this.params, r.dom_id, r.res.requestUrls[0])
        }
      }
    }
  }
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/byl/org/tag/model.vue